import styled from 'styled-components';
import { Container } from 'react-bootstrap';

export const AccountsContainer = styled(Container)`
  padding: 0 24px;
  @media screen and (min-width: 768px) {
    padding: 0 40px;
  }
`;

export const StyledH2 = styled.h2`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 135%;
  color: #2C2B48;
  margin-bottom: 66px;
`;